import { Injectable } from '@angular/core';
import { Events, LoadingController, Platform } from 'ionic-angular';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable()
export class ExportServices {

  constructor(public events: Events,
    public loadingCtrl: LoadingController,
    public platform: Platform) {
  }

  public exportAsExcelFile(json: any[], excelFileName: string): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  public exportAsExcelFoodCost(json: any[], excelFileName: string): void {

    var workbook = XLSX.utils.book_new();

    var count = 0;
    for (let dish of json) {
      var ws1 = XLSX.utils.json_to_sheet(dish.dish);
      XLSX.utils.sheet_add_json(ws1, dish.foodcost, { origin: -1 });
      XLSX.utils.book_append_sheet(workbook, ws1, count + '-' + dish.name.substring(0, 20));
      count++;

    }
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, excelFileName);

  }


  public exportAsExcelIncomeExpenses(json: any[], excelFileName: string): void {

    var workbook = XLSX.utils.book_new();

    for (let ie of json) {
      var ws1 = XLSX.utils.json_to_sheet(ie.inexp);
      //XLSX.utils.sheet_add_json(ws1, ie.inexp, { origin: -1 });
      XLSX.utils.book_append_sheet(workbook, ws1, ie.name.substring(0, 20));

    }
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, excelFileName);

  }




  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
    FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
  }


}



// WEBPACK FOOTER //
// ./src/pages/services/exportServices.ts